<script lang="ts">
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';

    import StyleLikeFilterItem from '../../shared/StyleLikeFilterItem.svelte';
    import { debug, defaultPageLink } from '../../../stores/store';
    import SelectLocation from '../Location/SelectLocation.svelte';
    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import { onMapReady } from '../../utilities/onMapReady';
    import { Navigation } from '../../utilities/Navigation';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import { Location } from '../Location/Location';
    import { ConnectionApi } from './ConnectionApi';
    import { Connection } from './Connection';
    import { api } from '../../../stores/api';
    import { mainMenu } from '../../../stores/store';
    import { JobOnMap } from './JobOnMap';
    import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import SuccessInline from '../../shared/SuccessInline.svelte';
    import WarningInline from '../../shared/WarningInline.svelte';
    import { NotificationSystem } from '../NotificationSystem/NotificationSystem';
    import TemplateSettingsGeneral from '../Settings/TemplateSettingsGeneral.svelte';
    import { Umami } from '../../utilities/Umami';
    import { app } from '../../../stores/app';

    export let connection: Connection;
    export let startPointOnMap: () => void;
    export let jobOnMap: JobOnMap;
    export let jobGeocodedOnMap: JobOnMap;
    export let triedToSave: boolean = false;

    let savingError: string = '';
    let validateErrors: string[] = [];
    let saving: boolean = false;
    let loading: boolean = true;
    let validated: boolean = false;
    let createReturnConnection: boolean = false;

    let savedData: Connection = new Connection();

    let savedWithSuccess: boolean = false;

    let locationFrom: Location = new Location();
    let locationTo: Location = new Location();

    async function saveJob() {
        saving = true;
        savedWithSuccess = false;
        connection.setRequest({
            location_id_from: locationFrom.getId(),
            location_id_to: locationTo.getId(),
            is_ad_hoc: true,
            note: '',
        });
        console.log('Saving connection', connection);
        let response = await ConnectionApi.createOne($api, connection.getRequest()).catch(error => {
            console.error('saveJob1', error);
            savingError = 'Error saving connection';
            Umami.error('connection_created', error);
        });
        let responseReturn = null;
        if (createReturnConnection) {
            let connectionReturn = new Connection().setRequest({
                location_id_from: locationTo.getId(),
                location_id_to: locationFrom.getId(),
                is_ad_hoc: true,
                note: '',
            });
            responseReturn = await ConnectionApi.createOne($api, connectionReturn.getRequest()).catch(error => {
                console.error('saveJob2', error);
                savingError = 'Error saving connection';
            });
        }
        console.log('saveJob', response);
        if (response && (responseReturn || !createReturnConnection)) {
            savedWithSuccess = true;
            savedData = new Connection().set(response);
            $NotificationSystem.reload();
            Umami.event('connection_created', { connection_id: response.id ?? null });
        }
        // validated = await validate(locationFrom, locationTo, createReturnConnection);
        $mainMenu.items.find(item => item.id === 'PageConnection').notification.reload = true;
        $mainMenu = $mainMenu;
        saving = false;
    }

    onMount(() => {
        loading = true;
        Promise.all([onMapReady()])
            .then(() => {
                // if (connection.hasCoords()) {
                //     let x = connection.getX();
                //     let y = connection.getY();
                //     if (x !== null && y !== null) {
                //         jobOnMap.addPoint(x, y, '#70a0ff', 'Punkt');
                //         jobOnMap.centerMap();
                //     }
                // }
                loading = false;
            })
            .catch(e => {
                console.error('Error loading map', e);
            });

        return () => {
            jobOnMap.clear();
            jobGeocodedOnMap.clear();
        };
    });

    function onSelectLocationFrom(location: Location) {
        locationFrom = location;
    }

    function onSelectLocationTo(location: Location) {
        locationTo = location;
    }

    async function validate(locationFrom: Location, locationTo: Location, createReturnConnection: boolean): Promise<boolean> {
        validateErrors = [];

        console.log('validate', locationFrom, locationTo, createReturnConnection);

        if (locationFrom.getExtId() === null) {
            // validateErrors.push('Wybierz punkt początkowy');
            return false;
        }

        if (locationTo.getExtId() === null) {
            // validateErrors.push('Wybierz punkt końcowy');
            return false;
        }

        if (locationFrom.getExtId() !== null && locationFrom.getExtId() === locationTo.getExtId()) {
            validateErrors.push($_('Start and end points are the same'));
        }

        if (validateErrors.length === 0) {

            let connectionCount = 0;
            if (!$app.settingsReadonly?.allow_limit_exceeding && $app.settingsReadonly?.max_connections) {
                await ConnectionApi.getCountWithQueries($api, {}, new ApiFilterBuilder(-1)).then((response) => {
                    connectionCount = response?.count || 0;
                });
                if (connectionCount >= $app.settingsReadonly?.max_connections) {
                    validateErrors.push($_('max_connections_exceeded_manual'));
                }
            }

            await ConnectionApi.getCountWithQueries(
                $api,
                {
                    location_id_from: locationFrom.getId(),
                    location_id_to: locationTo.getId(),
                },
                new ApiFilterBuilder(1)
            ).then(response => {
                if (response.count > 0) {
                    validateErrors.push($_('Connection already exists'));
                }
            });

            if (createReturnConnection) {

                if (!$app.settingsReadonly?.allow_limit_exceeding && $app.settingsReadonly?.max_connections) {
                    if (connectionCount >= $app.settingsReadonly?.max_connections - 1) {
                        validateErrors.push($_('max_connections_exceeded_manual'));
                    }
                }

                await ConnectionApi.getCountWithQueries(
                    $api,
                    {
                        location_id_from: locationTo.getId(),
                        location_id_to: locationFrom.getId(),
                    },
                    new ApiFilterBuilder(1)
                ).then(response => {
                    if (response.count > 0) {
                        validateErrors.push($_('Return connection already exists'));
                    }
                });
            }
        }

        console.log('validateErrors', validateErrors);
        validateErrors = validateErrors;

        return validateErrors.length === 0;
    }

    $: {
        savedWithSuccess = false;
        validated = false;
        (async () => {
            validated = await validate(locationFrom, locationTo, createReturnConnection);
        })();
    }
</script>

{#if loading}
    <Spinner />
{:else}
    <TemplateSettingsGeneral>
        <!--    <div slot="label">{$_('Czy aktywna')}</div>-->
        <div slot="content">
            <!--    <div style="display: flex; padding: 0px 0px; flex-direction: column; row-gap: 10px;">-->
            <div
                style="display: flex; flex-direction: row; row-gap: 5px; width: 100%;
justify-content: space-between;
flex-wrap: wrap; column-gap: 5px;"
            >
                <StyleLikeFilterItem mode="vehicle">
                    <SelectLocation location={locationFrom} title={$_('Select start point')} onSelect={onSelectLocationFrom} />
                </StyleLikeFilterItem>
                <StyleLikeFilterItem mode="vehicle">
                    <SelectLocation location={locationTo} title={$_('Select end point')} onSelect={onSelectLocationTo} />
                </StyleLikeFilterItem>
            </div>
            <div style="margin:10px 0;">
                <Checkbox label={$_('Create return connection too')} bind:checked={createReturnConnection} />
            </div>
            <div>
                {#each validateErrors as error}
                    <WarningInline text={error} />
                {/each}
            </div>
            <div style="display: flex; flex-direction: row; justify-content: flex-end; column-gap: 20px">
                {#if savedWithSuccess && !saving}
                    <SuccessInline text={$_('Connection saved')} />
                {/if}
                <ButtonMain
                    requiresWrite={true}
                    disabled={!validated || saving || savedWithSuccess}
                    text={$_('Add route')}
                    on:click={() => {
                        triedToSave = true;
                        saveJob();
                    }}
                />
            </div>
            <!--    </div>-->
        </div>
    </TemplateSettingsGeneral>
{/if}

<style>
    .error {
        color: var(--automapa-red);
        padding: 5px;
        font-size: 14px;
    }
</style>
